
import { removeUserSession } from '../utils/Common';

import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MainListItems from './listItems';
import Usuarios from '../pages/Usuarios';
import BusBases from '../pages/BusBases';
import BusBase from '../pages/BusBase';
import BusTipos from '../pages/BusTipos';
import BusTipo from '../pages/BusTipo';
/*Tarea GDM-700 - Inicio */
import Emails from '../pages/Emails';
import Email from '../pages/Email';
/*Tarea GDM-700 - Fin */
import Cotizaciones from '../pages/Cotizaciones';
import Cotizacion from '../pages/Cotizacion';
import Usuario from '../pages/Usuario';
import MailTemplates from '../pages/MailTemplates';
import MailTemplate from '../pages/MailTemplate';
import Precios from '../pages/Precios';
import Rutas from '../pages/Rutas';
import Precio from '../pages/Precio';
import app from '../base/api';
import Dashboard from './Dashboard'
import { Routes, Route, useNavigate } from "react-router-dom";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme();

function AppContent() {
  const navigate = useNavigate();

  // handle click event of logout button
  const handleLogout = () => {
    removeUserSession();
    app.post('/logout/', new FormData(), {});
    navigate('/login');
  }

  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              Cotizador Bus Plus
            </Typography>
            <Button onClick={handleLogout} variant="contained" color="success">
              Salir
            </Button>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List><MainListItems/></List>
          <Divider />
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
            <Routes>
              <Route path="" element={<Dashboard />} />
              <Route path="busbases" element={<BusBases />} />
              {/*Tarea GDM-700 -Inicio */}
              <Route path="emails" element={<Emails />} />
              {/*Tarea GDM-700 -Fin */}
              <Route path="bustipos" element={<BusTipos />} />
              <Route path="cotizaciones" element={<Cotizaciones />} />
              <Route path="usuarios" element={<Usuarios />} />
              <Route path="mailtemplates" element={<MailTemplates />} />
              <Route path="precios" element={<Precios />} />
              <Route path="rutas" element={<Rutas />} />

              <Route path="usuarios/:id" element={<Usuario />} />
              <Route path="busbases/:id" element={<BusBase />} />
              <Route path="bustipos/:id" element={<BusTipo />} />
              {/*Tarea GDM-700 - Inicio */}
              <Route path="emails/:id" element={<Email />} />
              {/*Tarea GDM-700 - Fin */}
              <Route path="cotizaciones/:id" element={<Cotizacion />} />
              <Route path="mailtemplates/:id" element={<MailTemplate />} />
              <Route path="precios/:id" element={<Precio />} />
            </Routes>

        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default AppContent;